import EnvironmentVariablesInterfaceV1 from './EnvironmentVariablesInterfaceV1';
import { EnvironmentVariablesInterfaceV1Type } from '@clientos/types';

let environmentVariablesInterfaceV1: EnvironmentVariablesInterfaceV1;

/**
 * Initializes the environment variables interface V1
 * @returns Promise resolving to the environment variables interface
 */
export default async function initializeEnvironmentVariablesInterfaceV1(): Promise<EnvironmentVariablesInterfaceV1Type> {
  if (environmentVariablesInterfaceV1) {
    return environmentVariablesInterfaceV1.getInterface();
  }

  environmentVariablesInterfaceV1 = new EnvironmentVariablesInterfaceV1();

  return environmentVariablesInterfaceV1.getInterface();
}
